// Breadth (Jupiter): every constellation is worth a few points more.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import type { AlignmentDef } from '../types';

export const breadth: AlignmentDef = {
  id: 'breadth',
  planet: 'jupiter',
  name: 'Breadth',
  text: () => `Every constellation scores +${N.breadthAdd} points.`,
  wordAdd: () => N.breadthAdd,
};
